<template>
  <b-modal
    ref="integracoesModal"
    title="Integrações"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
  >
    <div class="container-table">
      <b-tabs
        justified
        class="mb-3"
      >
        <b-tab
          title="Omie"
          active
        >
          <OmieIntegrationTab />
        </b-tab>

        <b-tab
          title="G-Click"
        >
          <GClickIntegrationTab />
        </b-tab>
      </b-tabs>

    </div>

  </b-modal>
</template>

<style lang="scss">

.container-table {
min-height: 70vh;
overflow-y: auto;
margin-bottom: 1rem;

}

.sucesso-integracao {
  color: #28c76f;
}

.erro-integracao {
  color: #ea5455;
}

.pendente-integracao {
  color: #ffc107;
}

.disable-click {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.list-servico {
  border: 1px solid;
}

.btn-info button {
  height: 27px;
}

.row-table-faturamento{
  padding: 5px !important;
}

.column-acoes {
  padding: 5px 5px 5px 15px !important;
}
</style>

<script>
export default {
  nome: 'IntegracoesModal',
  components: {
    GClickIntegrationTab: () => import('../GClickIntegrationTab.vue'),
    OmieIntegrationTab: () => import('../OmieIntegrationTab.vue'),
  },
  methods: {
    show() {
      // this.servicosStatus = this.getTodosServicos
      this.$refs.integracoesModal.show()
    },
  },
}
</script>
